import { Box, Button, Container, Flex, HStack, Portal, Spacer, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useDisclosure, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { BsChevronRight, BsPlus } from "react-icons/bs";
import { NumericFormat } from "react-number-format";
import { useNavigate, useParams } from "react-router-dom";
import { Budget, IGetSponsors } from "../../../models/admin/sponsors.model";
import SponsorService from "../../../services/admin/sponsors.service";

import Loading from "../../common/Loading";
import AdminDashboardHeader from "../AdminHeader";
import AdminSidebar from "../AdminSidebar";
import { CreateBudgetModal } from "./CreateBudgetModal";
import { PayBudgetModal } from "./PayBudget";





const SponsorBudget = () => {
    const navigate = useNavigate()
    const [isBudget, setIsBudget] = useState(false);
    const [isPay, setIsPay] = useState(false);
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [loading, setLoading] = useState(true)
    const [budgetId, setBudgetId] = useState('')

    const { sponsor_id } = useParams();
    const [budgets, setBudgets] = useState<Budget[]>()
    const [sponsor, setSponsor] = useState<IGetSponsors>()

    const [sponsorTrainees, setSponsorTrainees] = useState<any[]>()
    const [budgetAmount, setBudgetAmount] = useState<number>(0)
    const [totalPaid, setTotalPaid] = useState<number>(0)
    const [reload, setReload] = useState(false)




    useEffect(() => {

        SponsorService.getEachSponsor(sponsor_id).then(
            (res) => {
                setBudgets(res.budgets)
                setSponsor(res)
                
                setLoading(false)
                const budgetAmount: number[] = [];
                res.budgets.forEach((budget) => budgetAmount.push(parseFloat(budget.amount)))
                const totalBudget = budgetAmount.reduce((a, b) => a + b, 0)
                setBudgetAmount(totalBudget)

                const paidBudget: number[] = [];
                res.budgets.forEach((budget) => paidBudget.push(parseFloat(budget.paid)))
                const totalPaid = paidBudget.reduce((a, b) => a + b, 0)
                setTotalPaid(totalPaid)
            }
        ).catch((err) => err);

    }, [reload]);
    const openBudgetModal = async () => {
        setIsBudget(true);
        setIsPay(false)
        onOpen();
    };
    const openPaymentModal = async (uuid: string) => {
        setIsBudget(false);
        setIsPay(true)
        onOpen();
        setBudgetId(uuid)
    };
const reloadData = () =>{
    setReload(!reload)
}

    return (
        <>{
            loading ? <Loading /> :
                <Box>
                    <Flex>
                        <Box width='18%' position='fixed' top='0' left='0' zIndex='1'>
                            <AdminSidebar />
                        </Box>
                        <Box width='82%' ml='18%' >
                            <AdminDashboardHeader />
                            <Box bg='#F9F8F8' height='100%' pr='10%' pt='30px' pl='40px' >
                                <Flex
                                    justifyContent="space-between"
                                    alignItems="center"
                                    py="26px"
                                >
                                    <HStack spacing='5px' >
                                        <Text color="#2B2B2B" fontWeight="500" fontSize="16px" cursor='pointer' onClick={() => { navigate(-1) }}> Sponsor</Text>
                                        <BsChevronRight />
                                        <Text color='#EC3337' fontWeight="400" fontSize="16px" textTransform='capitalize'> {sponsor?.organization_name ? sponsor.organization_name : 'nil'}</Text>
                                    </HStack>

                                </Flex>
                                <Flex
                                    justifyContent="space-between"
                                    pb="20px"
                                    mb="20px"
                                >

                                    <Container
                                        bg="white"

                                        borderRadius="5px"
                                        pl='50px'
                                        pr='70px'
                                        py={2}
                                        boxShadow="base"
                                        m={0}
                                    >
                                        <VStack pb={2} pt={1}>
                                            <Text color="#353535" fontSize='30px' fontWeight='700' >
                                                {sponsor?.organization_name ? sponsor.organization_name : 'Nil'}
                                            </Text>
                                            <Text color="#959595" fontWeight="500" fontSize='20px'>
                                                SPN- {sponsor?.code ? sponsor.code : 'Nil'}
                                            </Text>

                                        </VStack>
                                    </Container>

                                    <Spacer mx={3} />

                                    <Container
                                        px={10}
                                        py={5}
                                        borderRadius="5px"
                                        boxShadow="base"
                                        width='50%'
                                        bg="white"
                                        m={0}
                                    >
                                        <VStack pb={3} pt={1}>
                                            <Text color="#959595" fontSize='14px'>
                                                {" "}
                                                Wallet
                                            </Text>
                                            <Text color="#353535" fontWeight="700" fontSize={20}>
                                                <NumericFormat
                                                    value={totalPaid}
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    prefix={"₦"}
                                                />
                                            </Text>


                                        </VStack>
                                    </Container>
                                    <Spacer mx={3} />
                                    <Container
                                        px={10}
                                        py={5}
                                        borderRadius="5px"
                                        boxShadow="base"
                                        width='50%'
                                        bg="white"
                                        m={0}
                                    >
                                        <VStack pb={3} pt={1}>
                                            <Text color="#959595" fontSize='14px'>
                                                {" "}
                                                Balance
                                            </Text>
                                            <Text color="#353535" fontWeight="700" fontSize={20}>
                                                <NumericFormat
                                                    value={budgetAmount}
                                                    displayType={"text"}
                                                    thousandSeparator={true}
                                                    prefix={"₦"}
                                                />
                                            </Text>
                                            <HStack spacing='5px' cursor='pointer' fontWeight='700' onClick={() => { openBudgetModal() }} fontSize='12px' color='#EC3337'>
                                                <BsPlus />
                                                <Text>Add to balance</Text>

                                            </HStack>

                                        </VStack>
                                    </Container>
                                </Flex>
                                <Box pl='48px' pt='32px' width='100%' bg='white' pb='80px'>
                                    <Box width='100%'>
                                        <TableContainer >
                                            <Table variant='simple' >
                                                <Thead mb='10px' >
                                                    <Tr pb='10px' fontSize='14px' borderBottom='1px solid' borderColor='#D5D5D5'>

                                                        <Th textTransform='none'>S/N</Th>
                                                        <Th textTransform='none'>Balance </Th>
                                                        <Th textTransform='none'>Amount Used</Th>
                                                        <Th textTransform='none'>Amount Paid</Th>
                                                       
                                                        <Th textTransform='none' >Options</Th>
                                                    </Tr>
                                                </Thead>
                                                <Tbody>

                                                    {
                                                        budgets && budgets?.length > 0 ?
                                                            budgets.map((each, index) => (
                                                                <Tr key={index} bg='white' fontSize='14px' >
                                                                    <Td>
                                                                        <Text>{index + 1}</Text>
                                                                    </Td>

                                                                    <Td >
                                                                        <Text textTransform='capitalize'>  <NumericFormat
                                                                            value={each.amount}
                                                                            displayType={"text"}
                                                                            thousandSeparator={true}
                                                                            prefix={"₦"}
                                                                        /></Text>
                                                                    </Td>
                                                                    <Td >    <Text>{<NumericFormat
                                                                        value={each.amount_used}
                                                                        displayType={"text"}
                                                                        thousandSeparator={true}
                                                                        prefix={"₦"}
                                                                    />}</Text></Td>
                                                                    <Td>    <Text ><NumericFormat
                                                                        value={each.paid}
                                                                        displayType={"text"}
                                                                        thousandSeparator={true}
                                                                        prefix={"₦"}
                                                                    /></Text></Td>
                                                                   
                                                                    <Td>
                                                                        <Button py='20px' px='30px' onClick={() => { openPaymentModal(each.uuid) }} fontSize={12} colorScheme='red' size='sm'>
                                                                            Pay 
                                                                        </Button>
                                                                    </Td>

                                                                </Tr>
                                                            )) : <Box pl='48px' pt='32px' width='100%' bg='white' pb='80px'>
                                                                <Flex mb='90px' justifyContent='space-between'>
                                                                    <Text textAlign='center' fontWeight='500' fontSize='20px' color='#2B2B2B'>No Budget yet</Text>

                                                                </Flex>
                                                                <Text textAlign='center' mt='10px' fontWeight='400' onClick={() => { openBudgetModal() }} fontSize='14px' color='#EC3337' cursor='pointer'>Create Budget</Text>
                                                            </Box>

                                                    }
                                                </Tbody>

                                            </Table>
                                        </TableContainer>
                                    </Box>
                                </Box>

                            </Box>

                        </Box>
                    </Flex>
                    {isBudget && (
                        <Portal>
                            {" "}
                            <CreateBudgetModal
                                isOpen={isOpen}
                                onClosed={onClose}
                                isBudget={isBudget}
                                sponsorId={sponsor_id}
                                reload={reloadData}
                            />{" "}
                        </Portal>
                    )}
                    {isPay && (
                        <Portal>
                            {" "}
                            <PayBudgetModal
                                isOpenPay={isOpen}
                                onClosePay={onClose}
                                budgetId={budgetId}
                                isPay={isPay}
                                reload={reloadData}
                            />{" "}
                        </Portal>
                    )}
                </Box>
        }

        </>
    )
}

export default SponsorBudget;